import { addUploadedImagesAction, setUploadedImagesAction } from 'editor/src/store/gallery/slice';
import { UploadedImageData } from 'editor/src/store/gallery/types';
import toGalleryImages from 'editor/src/store/gallery/utils/toGalleryImages';
import type { ThunkDispatch } from 'editor/src/store/hooks';

const addUploadedImages =
  (inputImages: UploadedImageData[], clearExisting = false) =>
  async (dispatch: ThunkDispatch) => {
    if (!Array.isArray(inputImages)) {
      throw new Error(`inputImage should be an array. The actual value is: ${JSON.stringify(inputImages)}`);
    }

    const images = await toGalleryImages(inputImages);

    if (clearExisting) {
      dispatch(setUploadedImagesAction(images));
    } else {
      dispatch(addUploadedImagesAction(images));
    }
  };

export default addUploadedImages;
